module.exports = __webpack_public_path__ + "img/shiyong.38ab2fd0.png";